import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowAltCircleDown,
  faArrowCircleDown,
  faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons';

import { Separator, Colxx } from '../../../../../components/common/CustomBootstrap';
import Tooltip from './Tooltip';
import { BrowserRouter as Router, NavLink } from 'react-router-dom';
export default function PersistentMenuForm({ localeOptions, integration, persistentMenus }) {
  console.log(localeOptions);
  const RedirectToPersistentMenu = () => {
    window.location.href = '/app/pages/persistentmenu/' + integration.id;
  };
  return (
    <Card className="mb-4">
      <CardBody>
        <div className="text-center">
          <h6>Persistent Menu</h6>
          <Separator className="mb-3" />
          <Card className="m-4 p-4">
            <Colxx xxs="12 " className="p-0">
              <div className="mb-1">
                <b>Enable:</b>
                {integration.channelDetails.menuEnabled ? 'Yes' : 'No'}
              </div>
              <div>
                {persistentMenus.length > 0 ? (
                  persistentMenus.map((items, index) => {
                    return (
                      <Fragment>
                        <h2>
                          {items.locale === 'default'
                            ? 'Default'
                            : localeOptions
                              .filter((i) => i.id.includes(items.locale))
                              .map((item) => item.name) +
                            ' (' +
                            items.locale +
                            ')'}
                        </h2>
                        <div className="text-center">
                          {items.callToActions.map((menu) => {
                            return (
                              <Fragment>
                                <p>{menu.title}</p>
                                <span className="text-muted">
                                  ({' '}
                                  {menu.type === 'postback' ? (
                                    <span>
                                      {menu.payLoad}{' '}
                                      <i className="iconsminds-turn-up-2"></i>
                                    </span>
                                  ) : (
                                    <span>
                                      {menu.url}{' '}
                                      <FontAwesomeIcon icon={faExternalLinkAlt} />
                                    </span>
                                  )}{' '}
                                  )
                                </span>
                              </Fragment>
                            );
                          })}
                        </div>
                      </Fragment>
                    );
                  })
                ) : (
                  <Fragment>
                    <p>No persistent menu found</p>
                  </Fragment>
                )}
              </div>
            </Colxx>
          </Card>
          <Separator className="my-3" />
          <NavLink
            to={{ pathname: '/app/pages/persistentmenu/' + integration.id }}
            className={`btn btn-outline-success btn-xs`}
            style={{
              marginBottom: '5px',
              display: 'inline-block',
              color: 'white',
            }}
            key={integration.id}
          >
            {' '}
            Edit
          </NavLink>
        </div>
      </CardBody>
    </Card>
  );
}
